(function () {
  'use strict';

  // ---------- Buy box: gallery, pack selector, sticky bar ----------
  document.querySelectorAll('[data-k-product]').forEach(function (root) {
    var mainImg = root.querySelector('[data-k-main-img]');
    var thumbs = root.querySelectorAll('[data-k-thumb]');
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var sticky = document.querySelector('[data-k-sticky]');

    // Gallery: swipeable slides (scroll-snap) + arrows + thumbnails
    var track = root.querySelector('[data-k-slides]');
    var slides = track ? track.querySelectorAll('[data-k-slide]') : [];
    var target = 0;
    function goTo(i) {
      if (!track || !slides.length) return;
      target = (i + slides.length) % slides.length;
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }
    function markThumb(i) {
      thumbs.forEach(function (o, k) {
        if (k === i) o.setAttribute('aria-current', 'true'); else o.removeAttribute('aria-current');
      });
    }
    function currentIndex() {
      return track ? Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) : 0;
    }
    if (track) {
      var raf = null, settle = null;
      track.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = null; markThumb(currentIndex()); });
        // Once a swipe settles, that slide becomes the reference for the arrows
        clearTimeout(settle);
        settle = setTimeout(function () { target = currentIndex(); }, 150);
      }, { passive: true });
    }
    var prev = root.querySelector('[data-k-prev]');
    var next = root.querySelector('[data-k-next]');
    if (prev) prev.addEventListener('click', function () { goTo(target - 1); });
    if (next) next.addEventListener('click', function () { goTo(target + 1); });

    function showImage(src, srcset, alt) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (srcset) { mainImg.srcset = srcset; } else { mainImg.removeAttribute('srcset'); }
      if (alt) mainImg.alt = alt;
      goTo(0);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        markThumb(i);
        if (slides.length > i) {
          // Slide 0 may have been swapped for a pack photo: put the gallery image back
          var img = slides[i].querySelector('img');
          if (img && t.dataset.src && img.getAttribute('src') !== t.dataset.src) { img.src = t.dataset.src; img.removeAttribute('srcset'); img.alt = t.dataset.alt || ''; }
          goTo(i);
        } else {
          showImage(t.dataset.src, t.dataset.srcset, t.dataset.alt);
        }
      });
    });

    function applyPack(input, userAction) {
      if (!input) return;
      if (idInput && input.dataset.variantId) {
        idInput.value = input.dataset.variantId;
        // Let apps (EasySell, pixels…) know the variant changed
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (qtyInput && input.dataset.qty) {
        qtyInput.value = input.dataset.qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (userAction && input.dataset.img) {
        thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
        showImage(input.dataset.img, '', input.dataset.title);
      }
      if (sticky) {
        var t = sticky.querySelector('[data-k-sticky-title]');
        var p = sticky.querySelector('[data-k-sticky-price]');
        if (t) t.textContent = input.dataset.title || '';
        if (p) p.textContent = input.dataset.price || '';
      }
    }

    var packs = root.querySelectorAll('input[data-k-pack]');
    packs.forEach(function (input) {
      input.addEventListener('change', function () { applyPack(input, true); });
    });
    applyPack(root.querySelector('input[data-k-pack]:checked') || packs[0], false);

    // Native fallback when no COD-form app takes over the button:
    // empty the cart, add the chosen pack, go straight to checkout.
    if (form && root.dataset.buyMode === 'checkout') {
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        var body = JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qtyInput && qtyInput.value) || 1 }] });
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body });
          })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            window.location.href = '/checkout';
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            form.submit();
          });
      });
    }

    // When EasySell adds its cash-on-delivery button, ours becomes the "pay by card" alternative
    var ctaBtn = form ? form.querySelector('.k-cta') : null;
    if (ctaBtn) {
      var relabel = function () {
        if (!form.querySelector('.es-popup-button')) return false;
        // EasySell is the only way to order: hide the native Shopify button
        ctaBtn.hidden = true;
        return true;
      };
      if (!relabel() && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { if (relabel()) mo.disconnect(); });
        mo.observe(form, { childList: true, subtree: true });
      }
    }

    // Sticky bar appears once the buy button has scrolled out of view
    if (sticky && form && 'IntersectionObserver' in window) {
      document.body.classList.add('k-has-sticky');
      var cta = form.querySelector('[type="submit"]') || form;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', !en.isIntersecting && below);
        });
      }).observe(cta);
    }
  });

  // ---------- Keep the EasySell offer in step with the pack chosen on the page ----------
  // EasySell lists its quantity offers in the same order as our pack blocks (1 / 3 / 5)
  // and ignores the form's quantity input, so we pick the matching offer once the popup renders.
  function syncOrderFormOffer() {
    var packs = Array.prototype.slice.call(document.querySelectorAll('input[data-k-pack]'));
    var checked = packs.filter(function (p) { return p.checked; })[0];
    if (!checked) return;
    var idx = packs.indexOf(checked);
    var title = (checked.dataset.title || '').trim().toLowerCase();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var offers = document.querySelectorAll('.es-qo-container');
      if (!offers.length) { if (tries > 40) clearInterval(timer); return; }
      clearInterval(timer);
      var target = null;
      offers.forEach(function (o) {
        if (!target && title && o.textContent.trim().toLowerCase().indexOf(title) === 0) target = o;
      });
      if (!target) target = offers[idx];
      if (target && target.getAttribute('offer-selected') !== 'true') target.click();
    }, 100);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#es-popup-button, .es-popup-button')) syncOrderFormOffer();
  }, true);

  // ---------- "Order" buttons (header, sticky bar) open the EasySell form ----------
  function openOrderForm() {
    var es = document.querySelector('#es-popup-button, .es-popup-button');
    if (!es) return false;
    es.click();
    return true;
  }
  document.querySelectorAll('[data-k-open-form]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (openOrderForm()) { e.preventDefault(); return; }
      // No form on this page (e.g. home): go to the product page and open it there
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) === '#' || href.indexOf('k_order=1') > -1) return;
      e.preventDefault();
      var parts = href.split('#');
      window.location.href = parts[0] + (parts[0].indexOf('?') > -1 ? '&' : '?') + 'k_order=1' + (parts[1] ? '#' + parts[1] : '');
    });
  });
  if (/[?&]k_order=1/.test(window.location.search)) {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (openOrderForm() || tries > 40) clearInterval(timer);
    }, 250);
  }

  // ---------- Reviews: show more / less ----------
  document.querySelectorAll('[data-k-reviews]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-k-reviews-toggle]');
    if (!btn) return;
    var extra = wrap.querySelectorAll('[data-k-review-extra]');
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      extra.forEach(function (el) { el.hidden = open; });
      btn.setAttribute('aria-expanded', String(!open));
      btn.textContent = open ? btn.dataset.more : btn.dataset.less;
    });
  });

  // ---------- FAQ: one open at a time ----------
  document.querySelectorAll('[data-k-faq]').forEach(function (faq) {
    var items = faq.querySelectorAll('details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });
})();
